import Vue from 'vue'
import App from './App.vue'

import VueSocketIOExt from 'vue-socket.io-extended';
import { io } from 'socket.io-client';

//const socket = io('http://localhost:3000', {
const socket = io('http://mylws.mattkingz.cl', {
  autoConnect: false
});

Vue.use(VueSocketIOExt, socket);

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
Vue.component('VueSlider', VueSlider)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
